import { createAction } from '@reduxjs/toolkit'
import {
  LOGIN_REQUEST,
  LOGIN_RESPONSE,
  AUTH_TOKENS_UPDATED,
  NAVIGATE_MENU,
  LOGOUT,
  LOGIN_LOADING_REPONSE,
  SET_COMPANY_LOGO
} from "../constants/actions";

import StorageService from "../services/storage";

import { requestLogin, getSalesGuide as _getSalesGuide } from "../api";
import { Alert } from "react-native";

export function login(email, password) {
  return (dispatch, getState) => {
    dispatch(createAction(LOGIN_REQUEST)({ username: email }));
    setTimeout(()=>{
      dispatch(createAction(LOGIN_LOADING_REPONSE)());
    },3000);
    dispatch(
      createAction(LOGIN_RESPONSE)(
        requestLogin(dispatch, getState, { email, password }).then(
          (response) => {
            dispatch(createAction(NAVIGATE_MENU)(response));            
              return response; 
          }
        )
      )
    );
  };
}

export function logout() {
  return (dispatch, getState) => {
    dispatch(createAction(LOGOUT)());
  };
}

export function authTokensUpdated(data) {
  return { type: AUTH_TOKENS_UPDATED, payload: data };
}

export function getSalesGuide(id, callback){
  return (dispatch, getState) => {
    _getSalesGuide(dispatch, getState, id).then(
      (response) => {
        dispatch(createAction(SET_COMPANY_LOGO)(response));
        if(callback){
          setTimeout(()=>{
            callback(response);
          },100)
        }
        dispatch(authTokensUpdated(response));            
      }
    )
  }
}
